/**
 * @fileoverview The file manage dT Theme cookie based CompareList 
 * dT_General.js, axios, vue libs are dependencies. 
 * @package
 */
class dT_CompareList {

    constructor() {
        this.CompareListData = [];
        this.LOCAL_STORAGE_CompareLIST_KEY = 'shopify-Comparelist';
        this.LOCAL_STORAGE_DELIMITER = ',';
    }

    setListLocalStorageKey(LOCAL_STORAGE_CompareLIST_KEY, LOCAL_STORAGE_DELIMITER) {
        this.LOCAL_STORAGE_CompareLIST_KEY = LOCAL_STORAGE_CompareLIST_KEY;
        this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
    }

    setupGrid(listType) {
        var Comparelist = this.getComparelist();

        var requests = Comparelist.map(function (handle) {
            var productTileTemplateUrl = '/products/' + handle + '?view=json';
            var getProductsList = this.getProductResponse(productTileTemplateUrl);
            return getProductsList;
        }.bind(this));
      
        return Promise.all(requests).then(function (responses) {
            var ComparelistProductCards = responses.join('%$$%');
            var a_ComparelistRecords = ComparelistProductCards.split("%$$%");
            let recordsObj = [];

            if (Array.isArray(a_ComparelistRecords) && a_ComparelistRecords.length) {
                var index = 0;
                a_ComparelistRecords.forEach(record => {
                    var a_record = record.split("~~");
                    var recordObj = {
                        id: a_record[0],
                        product_title: a_record[1],
                        product_handle: a_record[2],
                        product_image: a_record[3],
                        vendor: a_record[4],
                        type: a_record[5],
                        money_price: a_record[6],
                        price_min: a_record[7],
                        price_max: a_record[8],
                        available: a_record[9],
                        price_varies: a_record[10],
                        variant_id: a_record[11],
                        variant_title: a_record[12],
                        sku: a_record[13],
                        description: a_record[14],
                        quantity: "1",
                        product_url: '/products/' + a_record[2]
                    };
                    recordsObj[index] = recordObj;
                    index = index + 1;
                });
            }
            return recordsObj;
        }).then(function(data) {
            this.CompareListData = data;  
            return data;
        }.bind(this));
    }

    getCompareListRecords() {
        return this.CompareListData;
    }

    getProductResponse(url) {
        var responseResult = fetch(url)
            .then((response) => { return response.text(); })
            .then((data) => { return data.replace(/^\s*[\r\n]/gm, ''); });
        return responseResult;
    }

    getTotalCount() {
        return this.getComparelist().length;
    }
  
    getComparelist() {
        var Comparelist = localStorage.getItem(this.LOCAL_STORAGE_CompareLIST_KEY) || false;
        if (Comparelist) return Comparelist.split(this.LOCAL_STORAGE_DELIMITER);
        return [];
    }

    setComparelist(array) {
        var Comparelist = array.join(this.LOCAL_STORAGE_DELIMITER);
        if (array.length) localStorage.setItem(this.LOCAL_STORAGE_CompareLIST_KEY, Comparelist);
        else localStorage.removeItem(this.LOCAL_STORAGE_CompareLIST_KEY);
        return Comparelist;
    }

    updateComparelist(handle) {
        var Comparelist = this.getComparelist();
        var indexInComparelist = Comparelist.indexOf(handle);
        if (indexInComparelist === -1) Comparelist.push(handle);
        else Comparelist.splice(indexInComparelist, 1);
        return this.setComparelist(Comparelist);
    }

    removeComparet(handle) {
        var Comparelist = this.getComparelist();
        // Fixed: Use filter instead of broken remove method
        Comparelist = Comparelist.filter(item => item !== handle);
        return this.setComparelist(Comparelist);
    }

    resetComparelist() {
        return this.setComparelist([]);
    }

    isAddedIntoList(handle) {
        var Comparelist = this.getComparelist();  
        return Comparelist.includes(handle);
    }
}

async function getDTProduct(url) {
    try {
        let res = await fetch(url);
        return res.text().then(function (text) {      
            return text;
        });
    } catch (error) {
        console.log(error);
    }
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// ========== dTXCompare Component (Add to Compare Button) ==========
class dTXCompare extends HTMLElement {
    constructor() {
        super();
        
        this.dTCompareList = new dT_CompareList();
        this.dTCompareList.setListLocalStorageKey('dt-compare-list', ',');

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        this.addCompareList = this.querySelector('.add-compare');
        
        if (this.addCompareList) {
            this.productHandle = this.addCompareList.getAttribute('data-product_handle');
            this.addCompareList.addEventListener('click', this.debouncedOnSubmit.bind(this));
            this.initLoad();
        }
    }

    onSubmitHandler(event) {
        event.preventDefault();

        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            window.location = "/pages/compare";
        } else {
            const CompTotal = this.dTCompareList.getTotalCount();
            
            if (CompTotal > 3) {   
                var CompareModal = document.getElementById("compareModal");
                var XBtn = document.getElementById("compareModalClose");
                document.querySelector('body').classList.add('alert-overlay-wrapper');
                if (CompareModal) CompareModal.style.display = "block"; 
                if (XBtn) {
                    XBtn.onclick = function() {
                        CompareModal.style.display = "none";
                        document.querySelector('body').classList.remove('alert-overlay-wrapper');
                    }
                }
                return;
            } else {
                this.addCompareList.classList.add("adding");
                this.dTCompareList.updateComparelist(this.productHandle);
                setTimeout(this.postAdd.bind(this), 500);
            }
        }
    }

    postAdd() {
        var dtxCount = document.getElementsByClassName('dtxc-compare-count');
        if (dtxCount.length > 0) {
            document.querySelector(".dtxc-compare-count").setAttribute('count', this.dTCompareList.getTotalCount());
        }
        this.addCompareList.classList.remove("adding");
        this.addCompareList.classList.add("added");
        
        // Dispatch event to update count displays
        const event = new CustomEvent('compare:updated', {
            detail: { totalCount: this.dTCompareList.getTotalCount() }
        });
        document.dispatchEvent(event);
    }

    initLoad() {
        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            this.addCompareList.classList.add("added");
        }
    }
}

// ========== dTXRemoveCompareItem Component (Remove from Compare Button) ==========
class dTXRemoveCompareItem extends HTMLElement {
    constructor() {
        super();
        this.removeItem = this.querySelector('.remove-item');
        
        if (!this.removeItem) {
            return;
        }
        
        this.grid_type = this.getAttribute('grid_type');
        
        // Try multiple ways to get the product handle
        this.productHandle = this.getProductHandle();
        
        this.debouncedOnSubmit = debounce((event) => {
            this.removeListItem(event);
        }, 500);
        
        this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    
    getProductHandle() {
        // Method 1: Get from data-product_handle attribute
        let handle = this.removeItem.getAttribute('data-product_handle');
        
        // Method 2: Check if it's a placeholder and try to get from parent row
        if (!handle || handle.includes('{') || handle === 'null' || handle === 'undefined') {
            const row = this.closest('tr');
            
            if (row) {
                // Try row id
                if (row.id && row.id.startsWith('row_')) {
                    handle = row.id.replace('row_', '');
                }
                // Try row data attribute
                else if (row.getAttribute('data-product-handle')) {
                    handle = row.getAttribute('data-product-handle');
                }
                // Try to find any element with product handle in the row
                else {
                    const handleElement = row.querySelector('[data-product-handle], [data-product_handle]');
                    if (handleElement) {
                        handle = handleElement.getAttribute('data-product-handle') || handleElement.getAttribute('data-product_handle');
                    }
                }
            }
        }
        
        // Method 3: If still placeholder, try to get from the button's parent elements
        if (!handle || handle.includes('{')) {
            let currentElement = this.removeItem.parentElement;
            while (currentElement && !handle) {
                if (currentElement.getAttribute && currentElement.getAttribute('data-product-handle')) {
                    handle = currentElement.getAttribute('data-product-handle');
                    break;
                }
                if (currentElement.getAttribute && currentElement.getAttribute('data-product_handle')) {
                    handle = currentElement.getAttribute('data-product_handle');
                    break;
                }
                currentElement = currentElement.parentElement;
            }
        }
        
        // Clean up the handle
        if (handle && handle.includes('{')) {
            handle = null;
        }
        
        return handle;
    }
    
    removeListItem(event) {
        event.preventDefault();
        
        // Try to get handle again if it's null
        if (!this.productHandle || this.productHandle.includes('{')) {
            this.productHandle = this.getProductHandle();
        }
        
        if (!this.productHandle) {
            alert('Could not identify product to remove');
            return;
        }
        
        // Direct localStorage manipulation for reliability
        const STORAGE_KEY = 'dt-compare-list';
        let currentList = localStorage.getItem(STORAGE_KEY);
        
        let compareArray = [];
        if (currentList) {
            compareArray = currentList.split(',');
        }
        
        // Check if product exists
        const index = compareArray.indexOf(this.productHandle);
        
        if (index !== -1) {
            // Remove the product
            compareArray.splice(index, 1);
            
            // Save back to localStorage
            if (compareArray.length === 0) {
                localStorage.removeItem(STORAGE_KEY);
            } else {
                localStorage.setItem(STORAGE_KEY, compareArray.join(','));
            }
            
            // Remove the row from DOM with animation
            const rowElement = this.closest('tr');
            if (rowElement) {
                rowElement.style.transition = 'opacity 0.3s ease-out';
                rowElement.style.opacity = '0';
                setTimeout(() => {
                    rowElement.remove();
                    this.updateUI(compareArray.length);
                }, 300);
            } else {
                this.updateUI(compareArray.length);
            }
            
            // Update all count displays
            this.updateCounts(compareArray.length);
            
            // Dispatch event
            const event = new CustomEvent('compare:updated', {
                detail: { totalCount: compareArray.length }
            });
            document.dispatchEvent(event);
            
        } else {
            
            // Try to find by partial match
            const matchingProduct = compareArray.find(item => this.productHandle.includes(item) || item.includes(this.productHandle));
            if (matchingProduct) {
                const newIndex = compareArray.indexOf(matchingProduct);
                compareArray.splice(newIndex, 1);
                localStorage.setItem(STORAGE_KEY, compareArray.join(','));
                const rowElement = this.closest('tr');
                if (rowElement) rowElement.remove();
                this.updateCounts(compareArray.length);
            }
        }
    }
    
    updateUI(totalCount) {
        const compareGrid = document.querySelector('dtx-compare-grid');
        if (totalCount === 0 && compareGrid && compareGrid.showEmptyState) {
            compareGrid.showEmptyState();
        }
    }
    
    updateCounts(totalCount) {
        const countElements = document.querySelectorAll('.dtxc-compare-count, .compare-count, dtx-compare-count');
        countElements.forEach(element => {
            const countSpan = element.querySelector('span');
            if (countSpan) {
                countSpan.textContent = totalCount;
            } else if (element.updateCountDisplay) {
                element.updateCountDisplay(totalCount);
            }
            if (element.hasAttribute && element.hasAttribute('count')) {
                element.setAttribute('count', totalCount);
            }
        });
    }
}

// Register the component
if (!customElements.get('dtx-remove-compare-item')) {
    customElements.define('dtx-remove-compare-item', dTXRemoveCompareItem);
}

// ========== dTXComparetGrid Component (Compare Grid Display) ==========
class dTXComparetGrid extends HTMLElement {
    constructor() {
        super();
        this.gridTemplate = this.querySelector('.grid_template');
        this.dtxTable = this.querySelector(".dtx-table");
        this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
        this.dtxTbody = this.dtxTable ? this.dtxTable.querySelector('.slick-wrapper') : null;
        this.grid_type = this.getAttribute('grid_type');
        this.headerRow = null;
        
        // Listen for compare updates
        document.addEventListener('compare:updated', this.handleCompareUpdate.bind(this));
    }
    
    handleCompareUpdate(event) {
        if (event.detail && typeof event.detail.totalCount !== 'undefined') {
            this.initLoad();
        }
    }

    initLoad() {
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }
        
        dTCompareList.setupGrid().then(function(data) {
            this.generateGrid(data);
            return data;
        }.bind(this)).catch(function(error) {
            console.error('Error loading products:', error);
            this.showEmptyState();
        }.bind(this));
    }
  
    generateGrid(a_records) {
        if (!this.dtxTbody) {
            return;
        }
        
        if (!this.gridTemplate) {
            return;
        }
        
        if (a_records && a_records.length > 0 && a_records[0] && typeof a_records[0].product_handle !== 'undefined') {
            const rows = this.dtxTbody.querySelectorAll('tr');
            if (rows.length > 0 && !this.headerRow) {
                this.headerRow = rows[0];
            }
            
            // Clear all existing rows
            while (this.dtxTbody.children.length > 0) {
                this.dtxTbody.removeChild(this.dtxTbody.firstChild);
            }
            
            // Add back the header row
            if (this.headerRow) {
                this.dtxTbody.appendChild(this.headerRow.cloneNode(true));
            }
            
            // Add each product as a new row
            a_records.forEach(function(record) {
                const newRow = this.createRowFromTemplate(record);
                if (newRow) {
                    this.dtxTbody.appendChild(newRow);
                }
            }.bind(this));
            
            // Hide empty state, show table
            if (this.dtxNoRecord) {
                this.dtxNoRecord.classList.add("dtx-grid-hide");
                this.dtxNoRecord.classList.remove("dtx-grid-show");
            }
            if (this.dtxTable) {
                this.dtxTable.classList.remove("dtx-grid-hide");
                this.dtxTable.classList.add("dtx-grid-show");
            }
        } else {
            this.showEmptyState();
        }
    }
    
    createRowFromTemplate(record) {
        const newRow = document.createElement('tr');
        newRow.id = 'row_' + (record.product_handle || record.id);
        newRow.setAttribute('data-product-handle', record.product_handle);
        
        const templateCells = this.gridTemplate.querySelectorAll('td');
        
        if (templateCells.length === 0) {
            return null;
        }
        
        templateCells.forEach(function(templateCell) {
            const newCell = document.createElement('td');
            if (templateCell.className) {
                newCell.className = templateCell.className;
            }
            const cellContent = templateCell.cloneNode(true);
            this.processElement(cellContent, record);
            while (cellContent.firstChild) {
                newCell.appendChild(cellContent.firstChild);
            }
            newRow.appendChild(newCell);
        }.bind(this));
        
        return newRow;
    }
    
    processElement(element, record) {
        const textNodes = this.getTextNodes(element);
        textNodes.forEach(textNode => {
            if (textNode.textContent && textNode.textContent.includes('{')) {
                let content = textNode.textContent;
                content = this.replacePlaceholders(content, record);
                textNode.textContent = content;
            }
        });
        
        const allElements = element.querySelectorAll('*');
        allElements.forEach(el => {
            this.processElementAttributes(el, record);
        });
        this.processElementAttributes(element, record);
    }
    
    processElementAttributes(el, record) {
    // Process src attribute
    if (el.hasAttribute('src')) {
        let src = el.getAttribute('src');
        src = this.replacePlaceholders(src, record);
        el.setAttribute('src', src);
    }
    
    // Process href attribute
    if (el.hasAttribute('href')) {
        let href = el.getAttribute('href');
        href = this.replacePlaceholders(href, record);
        el.setAttribute('href', href);
    }
    
    // Process data-product_handle attribute - FIXED
    if (el.hasAttribute('data-product_handle')) {
        let handle = el.getAttribute('data-product_handle');
        handle = this.replacePlaceholders(handle, record);
        el.setAttribute('data-product_handle', handle);
    }
    
    // Also check for data-product-handle (without underscore)
    if (el.hasAttribute('data-product-handle')) {
        let handle = el.getAttribute('data-product-handle');
        handle = this.replacePlaceholders(handle, record);
        el.setAttribute('data-product-handle', handle);
    }
    
    // Process data-product-variant-id attribute
    if (el.hasAttribute('data-product-variant-id')) {
        let variantId = el.getAttribute('data-product-variant-id');
        variantId = this.replacePlaceholders(variantId, record);
        el.setAttribute('data-product-variant-id', variantId);
    }
    
    // Process alt attribute
    if (el.hasAttribute('alt')) {
        let alt = el.getAttribute('alt');
        alt = this.replacePlaceholders(alt, record);
        el.setAttribute('alt', alt);
    }
    
    // Process title attribute
    if (el.hasAttribute('title')) {
        let title = el.getAttribute('title');
        title = this.replacePlaceholders(title, record);
        el.setAttribute('title', title);
    }
}
    
    getTextNodes(node) {
        const textNodes = [];
        const walker = document.createTreeWalker(
            node,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    if (node.textContent && node.textContent.trim() && node.textContent.includes('{')) {
                        return NodeFilter.FILTER_ACCEPT;
                    }
                    return NodeFilter.FILTER_SKIP;
                }
            }
        );
        while (walker.nextNode()) {
            textNodes.push(walker.currentNode);
        }
        return textNodes;
    }
    
    replacePlaceholders(text, record) {
    if (!text || typeof text !== 'string') return text;
    
    let result = text;
    
    // Direct replacement for product_handle
    result = result.replace(/{item.product_handle}/gi, record.product_handle || '');
    result = result.replace(/{item.product_url}/gi, record.product_url || '');
    result = result.replace(/{item.product_image}/gi, record.product_image || '');
    result = result.replace(/{item.product_title}/gi, record.product_title || '');
    result = result.replace(/{item.money_price}/gi, record.money_price || '');
    result = result.replace(/{item.variant_id}/gi, record.variant_id || '');
    result = result.replace(/{item.product_type}/gi, record.type || 'Nil');
    result = result.replace(/{item.product_sku}/gi, record.sku || 'Nil');
    result = result.replace(/{item.product_vendor}/gi, record.vendor || 'Nil');
    result = result.replace(/{item.product_description}/gi, record.description || 'Nil');
    
    // Handle availability
    let availabilityText = '';
    if (record.available === 'true') {
        availabilityText = (typeof DT_THEME !== 'undefined' && DT_THEME.strings) ? DT_THEME.strings.in_stock : 'In Stock';
    } else {
        availabilityText = (typeof window.variantStrings !== 'undefined') ? window.variantStrings.soldOut : 'Sold Out';
    }
    result = result.replace(/{item.available}/gi, availabilityText);
    
    return result;
}
    
    showEmptyState() {
    if (this.dtxTable) {
        this.dtxTable.classList.add("dtx-grid-hide");
        this.dtxTable.classList.remove("dtx-grid-show");
    }
    if (this.dtxNoRecord) {
        // Clear existing content without innerHTML
        while (this.dtxNoRecord.firstChild) {
            this.dtxNoRecord.removeChild(this.dtxNoRecord.firstChild);
        }
        
        // Create empty state container
        const emptyStateDiv = document.createElement('div');
        emptyStateDiv.className = 'empty-compare-state';
        
        // Create heading
        const heading = document.createElement('h3');
        heading.textContent = 'Nothing found to compare!';
        
        // Create paragraph
        const paragraph = document.createElement('p');
        paragraph.textContent = 'Add products to compare and see the differences';
        
        // Create continue shopping link
        const continueLink = document.createElement('a');
        continueLink.href = '/collections/all';
        continueLink.className = 'continue-shopping-btn';
        continueLink.textContent = 'Continue Shopping';
        
        // Append all elements
        emptyStateDiv.appendChild(heading);
        emptyStateDiv.appendChild(paragraph);
        emptyStateDiv.appendChild(continueLink);
        
        // Add to the empty state container
        this.dtxNoRecord.appendChild(emptyStateDiv);
        
        // Show the empty state
        this.dtxNoRecord.classList.remove("dtx-grid-hide");
        this.dtxNoRecord.classList.add("dtx-grid-show");
    }
}
    
    connectedCallback() {
        this.initLoad();
    }
}

// ========== dTXCompareCount Component (Count Display) ==========
class dTXCompareCount extends HTMLElement {
    static get observedAttributes() {
        return ['count'];
    }  
  
    constructor() {
    super();
    this.gridCountBubble = this.querySelector('.grid-count-bubble');
    this.grid_type =this.getAttribute('grid_type');

    this.handleCompareUpdate = this.handleCompareUpdate.bind(this);
}
    
    handleCompareUpdate(event) {
        if (event.detail && typeof event.detail.totalCount !== 'undefined') {
            this.updateCountDisplay(event.detail.totalCount);
        } else {
            this.initLoad();
        }
    }
    
   initLoad() {
    const compareList = new dT_CompareList();
    compareList.setListLocalStorageKey('dt-compare-list', ',');  
    
    const totalCount =
        compareList.getTotalCount();

    this.updateCountDisplay(totalCount);

}
    
    updateCountDisplay(totalCount) {

    totalCount = parseInt(totalCount) || 0;

    // Update all compare count elements
    document
        .querySelectorAll('.dtxc-compare-count')
        .forEach((countElement) => {

            const span = countElement.querySelector('span');

            if (span) {
                span.textContent = totalCount;
            }

            if (totalCount === 0) {

                countElement.classList.add('count-zero');
                countElement.classList.remove('count-exist');

                countElement.style.display = 'none';

            } else {

                countElement.classList.add('count-exist');
                countElement.classList.remove('count-zero');

                countElement.style.display = 'block';
            }

        });

}
    
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'count') {
            this.updateCountDisplay(newValue);
        }
    }

    connectedCallback() {

    // Delay to ensure DOM fully ready
    setTimeout(() => {

        this.gridCountBubble =
            this.querySelector('.grid-count-bubble');

        document.addEventListener(
            'compare:updated',
            this.handleCompareUpdate
        );

        this.initLoad();

    }, 100);

}
}

// ========== Register Custom Elements ==========
if (!customElements.get('dtx-compare')) {
    customElements.define('dtx-compare', dTXCompare);
}
if (!customElements.get('dtx-compare-grid')) {
    customElements.define('dtx-compare-grid', dTXComparetGrid);
}
if (!customElements.get('dtx-remove-compare-item')) {
    customElements.define('dtx-remove-compare-item', dTXRemoveCompareItem);
}
if (!customElements.get('dtx-compare-count')) {
    customElements.define('dtx-compare-count', dTXCompareCount);
}